import type { U3130InitLUPersonalization } from '../U3130TimesheetModel';
import { u2000HideExpenseAndEquipmentTabs } from '../../u2000Core/tools/u2000HideExpenseAndEquipmentTabs';

/** BL-0675 : même personnalisation org que U3129 — masquer onglets Dépenses et Équipement. */
export function u3130HideExpenseAndEquipmentTabs(personalization?: U3130InitLUPersonalization | null): boolean {
  return u2000HideExpenseAndEquipmentTabs(personalization);
}

/** Identifiants d’onglets masqués lorsque le flag perso est actif. */
export const U3130_HIDDEN_EXPENSE_EQUIPMENT_TAB_IDS = ['tabExpenses', 'tabEquipment'] as const;
